///////////////* Custom Scripts *///////////////
/////////////// Added by Wilson from Galadrim *///////////////


////* Swipe of custom featured blog post section *////

document.addEventListener('DOMContentLoaded', function() {
  const sliderWrapper = document.querySelector('.slides-wrapper-featured-blog-post');
  const slides = document.querySelectorAll('.slide-featured-blog-post');
  const prevButton = document.querySelector('.slider-prev');
  const nextButton = document.querySelector('.slider-next');

  // Vérifier si la section et les boutons existent avant d'exécuter le script
  if (!sliderWrapper || slides.length === 0 || !prevButton || !nextButton) {
      console.warn("La section du slider n'est pas présente sur cette page.");
      return;
  }

  let currentIndex = 0;
  const totalSlides = slides.length;

  function goToSlide(index) {
      currentIndex = (index + totalSlides) % totalSlides;
      sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  // 🔥 Lancement du changement automatique de slides toutes les 5s
  setInterval(() => {
      goToSlide(currentIndex + 1);
  }, 5000);

  // Boutons suivant/précédent avec boucle infinie
  nextButton.addEventListener('click', () => {
      goToSlide(currentIndex + 1);
  });

  prevButton.addEventListener('click', () => {
      goToSlide(currentIndex - 1);
  });

  // Fonctionnalité swipe
  let startX = 0;
  let isDragging = false;

  sliderWrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
  });

  sliderWrapper.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;

      if (diff > 50) {
          goToSlide(currentIndex + 1);
      } else if (diff < -50) {
          goToSlide(currentIndex - 1);
      }
      isDragging = false;
  });

  // Initialisation à la première slide
  goToSlide(0);
});


////* Swipe of custom collections carrousel section *////

document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.collections-carrousel-wrapper');
  const prevBtn = document.querySelector('.collections-carrousel-prev');
  const nextBtn = document.querySelector('.collections-carrousel-next');
  const indicatorsContainer = document.querySelector('.collections-carrousel-indicators');
  const carouselSection = document.querySelector('.collections-carrousel-section');
  
  // Exit if carousel elements aren't found
  if (!wrapper || !prevBtn || !nextBtn || !indicatorsContainer || !carouselSection) {
    console.warn("La section du carrousel ou les boutons ne sont pas présents sur cette page.");
    return;
  }

  // Fonction pour vérifier si un élément est visible dans le viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom >= 0
    );
  }

  // Flag pour suivre si le carrousel est visible
  let isCarouselVisible = false;

  // Vérification périodique de la visibilité du carrousel
  function checkCarouselVisibility() {
    isCarouselVisible = isElementInViewport(carouselSection);
  }
  
  // Vérifier immédiatement au chargement
  checkCarouselVisibility();
  
  // Vérifier à chaque scroll
  window.addEventListener('scroll', checkCarouselVisibility, { passive: true });
  
  // Ensure buttons are visible
  prevBtn.classList.add('visible');
  nextBtn.classList.add('visible');

  // Get all collection items
  const collectionItems = document.querySelectorAll('.collection-item-collection-carrousel');
  if (collectionItems.length === 0) {
    console.error("Aucun élément trouvé avec la classe '.collection-item-collection-carrousel'.");
    return;
  }

  // Convert to array for easier manipulation
  const items = Array.from(collectionItems);
  const totalItems = items.length;

  // Calculate how many items are visible at once based on viewport width
  const itemWidth = items[0].clientWidth;
  const wrapperWidth = wrapper.clientWidth;
  const visibleItems = Math.max(1, Math.floor(wrapperWidth / itemWidth));
  
  // Calculate how many "views" we have (number of possible scroll positions)
  const totalViews = Math.max(1, totalItems - visibleItems + 1);
  
  // Set up carousel state
  let currentView = 0;
  let isScrolling = false;
  
  // Prepare the wrapper for smooth transitions
  wrapper.style.scrollBehavior = 'smooth';
  
  // Create indicator dots (one for each unique view)
  indicatorsContainer.innerHTML = '';
  for (let i = 0; i < totalViews; i++) {
    const dot = document.createElement('button');
    dot.classList.add('carousel-dot');
    dot.setAttribute('aria-label', `View ${i + 1}`);
    dot.addEventListener('click', () => scrollToView(i));
    indicatorsContainer.appendChild(dot);
  }
  
  // Initial state
  updateActiveIndicator();
  
  // Clone the first and last few items for smooth circular navigation
  function setupCircularNavigation() {
    // Remove any existing clones
    document.querySelectorAll('.collection-clone').forEach(clone => clone.remove());
    
    // Clone the last items and add to the beginning
    for (let i = 0; i < visibleItems; i++) {
      const index = totalItems - visibleItems + i;
      if (index >= 0 && index < totalItems) {
        const clone = items[index].cloneNode(true);
        clone.classList.add('collection-clone', 'collection-clone-prepend');
        clone.setAttribute('aria-hidden', 'true');
        wrapper.insertBefore(clone, items[0]);
      }
    }
    
    // Clone the first items and add to the end
    for (let i = 0; i < visibleItems; i++) {
      if (i < totalItems) {
        const clone = items[i].cloneNode(true);
        clone.classList.add('collection-clone', 'collection-clone-append');
        clone.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(clone);
      }
    }
    
    // Adjust the initial scroll position to show the first real item
    wrapper.scrollLeft = items[0].offsetLeft - (items[0].previousElementSibling ? items[0].previousElementSibling.offsetWidth : 0);
  }
  
  // Set up the circular navigation
  setupCircularNavigation();
  
  // Scroll to a specific view with improved circular navigation
  function scrollToView(viewIndex, isCircularNavigation = false) {
    // Si le carrousel n'est pas visible, ne pas faire de scrolling automatique
    if (!isCarouselVisible || isScrolling) return;
    
    // Éviter les scrolls inutiles si déjà sur la bonne vue
    if (viewIndex === currentView && !isCircularNavigation) {
      return;
    }
    
    isScrolling = true;
    
    // Handle circular navigation
    if (viewIndex < 0) {
      viewIndex = totalViews - 1;
    } else if (viewIndex >= totalViews) {
      viewIndex = 0;
    }
    
    currentView = viewIndex;
    
    // Standard smooth scroll to the target position
    const targetOffset = items[viewIndex].offsetLeft;
    wrapper.scrollTo({
      left: targetOffset,
      behavior: 'smooth'
    });
    
    // Update the active indicator
    updateActiveIndicator();
    
    // Reset scrolling flag after animation completes
    setTimeout(() => {
      isScrolling = false;
      
      // Handle the circular wrap-around if needed
      if (currentView === 0) {
        // Check if we're near the cloned end items
        const farRight = wrapper.scrollWidth - wrapper.clientWidth - wrapper.scrollLeft;
        if (farRight < itemWidth / 2) {
          // We're at the cloned beginning, jump to the real beginning
          wrapper.style.scrollBehavior = 'auto';
          wrapper.scrollLeft = items[0].offsetLeft;
          setTimeout(() => {
            wrapper.style.scrollBehavior = 'smooth';
          }, 50);
        }
      } else if (currentView === totalViews - 1) {
        // Check if we're near the cloned beginning items
        if (wrapper.scrollLeft < itemWidth / 2) {
          // We're at the cloned end, jump to the real end
          wrapper.style.scrollBehavior = 'auto';
          wrapper.scrollLeft = items[totalViews - 1].offsetLeft;
          setTimeout(() => {
            wrapper.style.scrollBehavior = 'smooth';
          }, 50);
        }
      }
    }, 500);
  }
  
  // Update the active indicator dot
  function updateActiveIndicator() {
    document.querySelectorAll('.carousel-dot').forEach((dot, index) => {
      dot.classList.toggle('active', index === currentView);
    });
  }
  
  // Next button with circular navigation
  nextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (!isCarouselVisible) return;
    scrollToView(currentView + 1, true);
  });
  
  // Previous button with circular navigation
  prevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (!isCarouselVisible) return;
    scrollToView(currentView - 1, true);
  });
  
  // Handle manual scrolling - Simplification pour réduire les interférences
  let isManualScrolling = false;
  let scrollTimeout;
  
  // On n'utilise plus l'événement scroll standard qui peut interférer avec le scroll de la page
  // On utilise plutôt un système de vérification périodique
  
  // Fonction de vérification de la position du carrousel
  function checkCarouselPosition() {
    // Ne vérifier que si le carrousel est visible et qu'aucun défilement programmé n'est en cours
    if (!isCarouselVisible || isScrolling) return;
    
    const scrollPosition = wrapper.scrollLeft;
    
    // 1. Chercher quelle vue est la plus visible
    let closestView = 0;
    let closestDistance = Infinity;
    
    for (let i = 0; i < totalViews; i++) {
      const itemOffset = items[i].offsetLeft;
      const distance = Math.abs(itemOffset - scrollPosition);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestView = i;
      }
    }
    
    // Mettre à jour l'indicateur actif si nécessaire
    if (closestView !== currentView) {
      currentView = closestView;
      updateActiveIndicator();
    }
    
    // 2. Vérifier si on est dans une zone de clones et repositionner si nécessaire
    // Pour éviter les sauts de page, on ne fait plus de transition automatique ou de snap-back
    // à moins d'être dans une zone de clones extrême
    
    if (scrollPosition < items[0].offsetLeft - (itemWidth * 2)) {
      // Beaucoup trop à gauche - aller discrètement à la fin
      wrapper.style.scrollBehavior = 'auto';
      wrapper.scrollLeft = items[totalViews - 1].offsetLeft;
      currentView = totalViews - 1;
      updateActiveIndicator();
      setTimeout(() => {
        wrapper.style.scrollBehavior = 'smooth';
      }, 50);
    } 
    else if (scrollPosition > items[totalViews - 1].offsetLeft + (itemWidth * 2)) {
      // Beaucoup trop à droite - aller discrètement au début
      wrapper.style.scrollBehavior = 'auto';
      wrapper.scrollLeft = items[0].offsetLeft;
      currentView = 0;
      updateActiveIndicator();
      setTimeout(() => {
        wrapper.style.scrollBehavior = 'smooth';
      }, 50);
    }
  }
  
  // Vérification périodique de la position du carrousel toutes les 300ms
  // au lieu d'intercepter tous les événements de scroll
  const positionInterval = setInterval(checkCarouselPosition, 300);
  
  // Nettoyer l'intervalle si la page est déchargée
  window.addEventListener('beforeunload', () => {
    clearInterval(positionInterval);
  });
  
  // Touch/swipe handling - Approche complètement réécrite
  let touchStartX = 0;
  let touchStartY = 0;
  let touchStartTime = 0;
  let isDragging = false;
  
  wrapper.addEventListener('touchstart', function(e) {
    // Ne démarrer le suivi que si le carrousel est visible
    if (!isCarouselVisible) return;
    
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    isDragging = true;
    
    // Important: NE PAS empêcher le comportement par défaut
  }, { passive: true });
  
  // Suppression complète de l'événement touchmove pour éviter toute interférence avec le scroll
  
  wrapper.addEventListener('touchend', function(e) {
    if (!isDragging || !isCarouselVisible) return;
    isDragging = false;
    
    // Calcul uniquement à la fin du toucher pour déterminer l'intention
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const touchDuration = Date.now() - touchStartTime;
    
    // Calculer les distances parcourues
    const diffX = touchStartX - touchEndX;
    const diffY = Math.abs(touchStartY - touchEndY);
    
    // Ne traiter que les gestes clairement horizontaux et rapides (swipes intentionnels)
    // et ignorer les mouvements qui ressemblent à du scroll vertical
    if (Math.abs(diffX) > diffY * 2 && Math.abs(diffX) > 50 && touchDuration < 300) {
      if (diffX > 0) {
        // Swipe vers la gauche -> aller à droite
        scrollToView(currentView + 1, true);
      } else {
        // Swipe vers la droite -> aller à gauche
        scrollToView(currentView - 1, true);
      }
      
      // Une fois que nous avons déterminé qu'il s'agit d'un swipe intentionnel,
      // nous pouvons empêcher le comportement par défaut du navigateur
      e.preventDefault();
    }
    
    // Dans tous les autres cas, laisser le navigateur gérer normalement le toucher
  }, { passive: false });
  
  // Handle window resize
  window.addEventListener('resize', function() {
    // Recalculate visible items and total views
    const newWrapperWidth = wrapper.clientWidth;
    const newVisibleItems = Math.max(1, Math.floor(newWrapperWidth / itemWidth));
    const newTotalViews = Math.max(1, totalItems - newVisibleItems + 1);
    
    // Adjust if needed
    if (newTotalViews !== totalViews || newVisibleItems !== visibleItems) {
      // Update indicator dots
      indicatorsContainer.innerHTML = '';
      for (let i = 0; i < newTotalViews; i++) {
        const dot = document.createElement('button');
        dot.classList.add('carousel-dot');
        dot.setAttribute('aria-label', `View ${i + 1}`);
        dot.addEventListener('click', () => scrollToView(i));
        indicatorsContainer.appendChild(dot);
      }
      
      // Rebuild circular navigation with new visible items count
      setupCircularNavigation();
      
      // Make sure current view is valid
      currentView = Math.min(currentView, newTotalViews - 1);
      
      // Update to current view with new layout
      setTimeout(() => {
        scrollToView(currentView, false);
      }, 100);
    }
  });
});


//// SCRIPT POIDS VOLUMÉTRIQUE ////

  document.addEventListener("DOMContentLoaded", function() {
    console.log("[PoidsVolumétrique] DOMContentLoaded déclenché.");

    // Pour éviter d'attacher plusieurs fois le même listener
    const observedForms = new Set();

    /**
     * Attache le listener de calcul du poids volumétrique à un formulaire d'ajout au panier.
     */
    function attachVolumetricListener(form) {
      if (observedForms.has(form)) {
        return;
      }
      observedForms.add(form);

      // Vérifier qu'il s'agit bien d'un formulaire d'ajout au panier
      if (!form.action.includes("/cart/add")) {
        console.log("[PoidsVolumétrique] Form ignoré (action != '/cart/add').");
        return;
      }

      console.log(`[PoidsVolumétrique] Listener attaché sur le formulaire (id="${form.id}").`);

      form.addEventListener("submit", function(event) {
        try {
          // Rechercher l'élément contenant les métachamps de dimensions dans ce formulaire
          const dataDiv = form.querySelector("div[id^='product-data']");
          if (!dataDiv) {
            console.warn("[PoidsVolumétrique] Aucun élément data trouvé dans ce formulaire.");
            return; // On laisse le formulaire se soumettre normalement
          }

          // Récupérer et convertir les valeurs en nombre
          const longueur = parseFloat(dataDiv.getAttribute("data-length")) || 0;
          const largeur  = parseFloat(dataDiv.getAttribute("data-width"))  || 0;
          const hauteur  = parseFloat(dataDiv.getAttribute("data-height")) || 0;
          const factor = 5000;

          // Calcul du poids volumétrique pour 1 exemplaire
          let volumetricWeight = (longueur * largeur * hauteur) / factor;
          volumetricWeight = isNaN(volumetricWeight) ? 0 : volumetricWeight;

  // Récupérer la quantité indiquée dans le formulaire (par défaut 1)
  // (La quantité n'est pas utilisée ici pour le calcul du champ caché,
  //  afin de stocker le poids unitaire)
  const qtyInput = form.querySelector('input[name="quantity"]');
  const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

  const volumetricStr = volumetricWeight.toFixed(2) + " kg";
          console.log("[PoidsVolumétrique] Poids volumétrique calculé pour", quantity, "produit(s):", volumetricStr);

          // Vérifier si un champ caché pour le poids volumétrique existe déjà ; sinon, le créer
          let input = form.querySelector('input[name="properties[Poids Volumétrique]"]');
          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = "properties[_Poids Volumétrique]";
            form.appendChild(input);
          }
          input.value = volumetricStr;
          console.log("[PoidsVolumétrique] Champ caché mis à jour avec :", volumetricStr);
        } catch (error) {
          console.error("[PoidsVolumétrique] Erreur lors du calcul :", error);
        }
        // Laisser la soumission se faire normalement
      });
    }

    // Sélectionner tous les formulaires dont l'ID commence par "product-form"
    const productForms = document.querySelectorAll("form[id^='product-form']");
    console.log("[PoidsVolumétrique] Nombre de formulaires trouvés :", productForms.length);
    productForms.forEach(attachVolumetricListener);

    // Observer le DOM pour détecter l'ajout de nouveaux formulaires (par ex. via AJAX)
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches("form[id^='product-form']")) {
              attachVolumetricListener(node);
            } else {
              node.querySelectorAll && node.querySelectorAll("form[id^='product-form']").forEach(attachVolumetricListener);
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // *** MODIFICATION 2 : Ré-attacher le listener après un re-render du formulaire ***
    document.addEventListener("product:rerender", function(event) {
      // Supposons que l'HTML du nouveau formulaire est contenu dans event.detail.htmlFragment
      const newForm = event.detail.htmlFragment.querySelector("form");
      if (newForm) {
        attachVolumetricListener(newForm);
        console.log("[PoidsVolumétrique] Listener ré-attaché sur le formulaire re-rendu.");
      }
    });
  });


//// Script Modal Countries ////

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("country-language-modal");
  const closeModalBtn = document.getElementById("close-modal");
  const confirmBtn = document.getElementById("confirm-selection");

  const countryList = document.getElementById("country-list");
  const languageList = document.getElementById("language-list");
  const countrySearch = document.getElementById("country-search");

  const countryCodeInput = document.getElementById("country_code_input");
  const localeCodeInput  = document.getElementById("locale_code_input");
  const localizationForm = document.getElementById("localization-modal-form");

  if (!modal || !confirmBtn ||
      !countryList || !languageList || !countrySearch ||
      !countryCodeInput || !localeCodeInput || !localizationForm) {
    console.error("Un élément du modal est introuvable dans le DOM.");
    return;
  }

  // Function to detect user's country using IP
  async function detectUserCountry() {
    try {
      const response = await fetch('https://ipapi.co/json/');
      const data = await response.json();
      return data.country_code;
    } catch (error) {
      console.error('Error detecting country:', error);
      return null;
    }
  }

  // Function to determine language based on country
  function determineLanguage(countryCode) {
    // French speaking countries
    const frenchSpeakingCountries = ['FR', 'BE', 'CH', 'CA', 'LU', 'MC', 'SN', 'CI', 'CM', 'CD', 'BF', 'ML', 'NE', 'TG', 'BJ', 'CF', 'CG', 'GA', 'GN', 'GW', 'KM', 'MG', 'MR', 'RW', 'TD', 'VU'];
    
    // Russian speaking countries
    const russianSpeakingCountries = ['RU', 'BY', 'KZ', 'KG', 'UZ', 'TM', 'TJ', 'MD', 'UA'];

    if (frenchSpeakingCountries.includes(countryCode)) {
      return 'fr';
    } else if (russianSpeakingCountries.includes(countryCode)) {
      return 'ru';
    } else {
      return 'en';
    }
  }

  // Function to pre-select country and language in the modal
  function preSelectCountryAndLanguage(countryCode) {
    // Pre-select country
    const countryItem = countryList.querySelector(`[data-country-code="${countryCode}"]`);
    if (countryItem) {
      countryItem.click();
      console.log('Country pre-selected:', countryCode);
    }

    // Pre-select language based on country
    const languageCode = determineLanguage(countryCode);
    const languageItem = languageList.querySelector(`[data-locale-code="${languageCode}"]`);
    if (languageItem) {
      languageItem.click();
      console.log('Language pre-selected:', languageCode);
    }
  }

  // Vérifier immédiatement le flag dans localStorage
  if (localStorage.getItem("has_chosen_localization") === "true") {
    // Le modal reste caché
    modal.style.display = "none";
  } else {
    // Sinon, afficher le modal
    modal.style.display = "flex";
    
    // Detect and pre-select country and language
    detectUserCountry().then(countryCode => {
      if (countryCode) {
        preSelectCountryAndLanguage(countryCode);
      }
    });
  }

  // Désactiver le bouton close pour forcer la sélection (si souhaité)
  closeModalBtn.addEventListener("click", function() {
    // Si vous souhaitez empêcher l'utilisateur de fermer sans choisir, laissez ce handler vide ou commentez la ligne.
    // modal.style.display = "none";
  });

  // --- Sélection d'un pays
  countryList.querySelectorAll("li.country-item").forEach(li => {
    li.addEventListener("click", function() {
      countryList.querySelectorAll("li").forEach(el => el.classList.remove("selected"));
      this.classList.add("selected");
      const chosenCode = this.getAttribute("data-country-code");
      countryCodeInput.value = chosenCode;
      console.log("Pays choisi:", chosenCode);
    });
  });

  // --- Sélection d'une langue
  languageList.querySelectorAll("li.language-item").forEach(li => {
    li.addEventListener("click", function() {
      languageList.querySelectorAll("li").forEach(el => el.classList.remove("selected"));
      this.classList.add("selected");
      const chosenLocale = this.getAttribute("data-locale-code");
      localeCodeInput.value = chosenLocale;
      console.log("Langue choisie:", chosenLocale);
    });
  });

  // --- Barre de recherche pour filtrer les pays
  countrySearch.addEventListener("keyup", function (e) {
    if (e.key === "Enter") e.preventDefault();
    const filter = countrySearch.value.toLowerCase();
    const items = countryList.getElementsByTagName("li");
    for (let item of items) {
      let text = item.textContent.toLowerCase();
      item.style.display = text.includes(filter) ? "block" : "none";
    }
  });

  // --- Bouton "CONFIRM"
  confirmBtn.addEventListener("click", function() {
    if (!countryCodeInput.value) {
      alert("Please choose a country.");
      return;
    }
    if (!localeCodeInput.value) {
      alert("Please choose a language.");
      return;
    }

    localStorage.setItem("has_chosen_localization", "true");
    document.cookie = "has_chosen_localization=true; path=/;";
    modal.style.display = "none";
    localizationForm.submit();
  });
});






//// Scripts dynamic description meta field variants bloc text and collapsible tab ////

// Sélection du bloc principal de description
let productDescription = document.querySelector("#dynamic-description");
let collapsibleContent = document.querySelector(".accordion__content.prose");

// Fonction pour mettre à jour les descriptions
function updateDescriptions(variantId) {
  console.log("🔄 Mise à jour des descriptions pour la variante :", variantId);

  // Mise à jour de la description principale
  if (productDescription) {
    let newDescription = variantId && window.variantDescriptions[variantId] 
      ? window.variantDescriptions[variantId] 
      : productDescription.dataset.defaultText || productDescription.innerHTML;
    
    if (productDescription.innerHTML !== newDescription) {
      productDescription.innerHTML = newDescription;
      console.log("✅ Description principale mise à jour");
    }
  }

  // Mise à jour du contenu collapsible
  if (collapsibleContent) {
    // Sauvegarder la description par défaut du collapsible si ce n'est pas déjà fait
    if (!collapsibleContent.dataset.defaultText) {
      collapsibleContent.dataset.defaultText = collapsibleContent.innerHTML.trim();
    }

    let newDescription = variantId && window.variantDescriptions[variantId] 
      ? window.variantDescriptions[variantId] 
      : collapsibleContent.dataset.defaultText;
    
    if (collapsibleContent.innerHTML.trim() !== newDescription) {
      collapsibleContent.innerHTML = newDescription;
      console.log("✅ Description collapsible mise à jour");
    }
  }
}

// Écouter les changements de variante
document.addEventListener('variant:change', (event) => {
  const variantId = event.detail.variant.id;
  updateDescriptions(variantId);
});

// Écouter les changements de l'input de variante
document.addEventListener('change', (event) => {
  if (event.target.name === 'id') {
    updateDescriptions(event.target.value);
  }
});

// Initialisation des descriptions
if (productDescription || collapsibleContent) {
  const initialVariantId = document.querySelector('input[name="id"]')?.value;
  updateDescriptions(initialVariantId);
}
